import React from 'react';
import config from '../../../config';
import { ReactComponent as PhoneIcon } from '../../../assets/svg/phone.svg';
import styles from './phone.module.scss';
import { PhoneViewProps } from '../types';

const PhoneView = ({
  onClick,
  emitPhoneCallClickEvent,
}: PhoneViewProps) => (
  <>
    <a
      aria-label="Call us at (888) 900-1569"
      className={`${styles.phone} ${styles['phone-mobile']}`}
      href="tel:(888)-900-1569"
      onClick={emitPhoneCallClickEvent}
    >
      <PhoneIcon className={styles['phone-icon']} aria-hidden />
      <span className={styles['phone-number']}>888 900-1569</span>
    </a>
    <a
      className={`${styles.phone} ${styles['phone-desktop']}`}
      href={`${config.Z3_URL.replace(/\/$/, '')}/contact`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Call us at (888) 441-2418"
      onClick={() => { onClick(); emitPhoneCallClickEvent(); }}
    >
      <PhoneIcon className={styles['phone-icon']} aria-hidden />
      <span className={styles['phone-number']}>888 441-2418</span>
    </a>
  </>
);

export default PhoneView;
